import { useTranslation } from "@bounce/i18n"

import { PicturesSlider } from "../../Generic/PicturesSlider/PicturesSlider"
import type { StorePicture } from "@/libs/bounce/stores/types"

type StorePictureSliderProps = {
  className: string
  height?: number
  href?: string
  pictures: (StorePicture & { alt: string })[]
  subtitle?: string
  title: string
  width?: number
}

export const StorePicturesSlider = ({
  className,
  height = 640,
  href,
  pictures,
  subtitle,
  title,
  width = 640,
}: StorePictureSliderProps) => {
  const { t } = useTranslation()

  if (pictures.length === 0) {
    return null
  }

  return (
    <PicturesSlider
      name="StorePicturesSlider"
      className={className}
      pictures={pictures.map(({ externalId, alt }) => ({
        src: `https://cdn.usebounce.com/${externalId}/-/scale_crop/${width}x${height}/center/-/enhance/`,
        alt,
      }))}
      title={title}
      subtitle={subtitle}
      cta={t("cmp.storePicturesSlider.cta", "Book now")}
      href={href}
    />
  )
}
